import { FC, PropsWithChildren } from 'react';
import { useNavigate } from 'react-router-dom-v5-compat';
import { noop } from 'utils/noop';
import { BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { colors } from 'ui/theme';
import { TemplateSection } from 'modules/predictiveGoals/components/templates/FirstTimeTemplate/TemplatesSection';

import { UserSelectedInternalTemplate, InternalTemplates } from '../../types';
import {
  INDEX_PAGE_TITLE,
  INDEX_PAGE_CREATE_TEXT,
  INDEX_PAGE_CREATE_BUTTON_TEXT,
} from '../../constants';
import {
  IndexPageContainer,
  IndexPageCreateNewContainer,
  IndexPageCreateNewText,
  IndexPageCreationButton,
  IndexPageTitle,
} from './PredictiveGoalsInitialPage.styles';

export const PageTestIds = {
  TemplatesInitialPage: 'templates-initial-page',
  TemplatesInitialPageCreate: 'templates-initial-page-create',
};

export interface PredictiveGoalsInitialPageProps {
  children?: React.ReactNode;
  getIsTemplateEventDisabled?: (event: UserSelectedInternalTemplate) => boolean;
  onCreateNew?: () => void;
  onSelectedEvent?: (event: UserSelectedInternalTemplate) => void;
}
export const PredictiveGoalsInitialPage: FC<PropsWithChildren<PredictiveGoalsInitialPageProps>> = ({
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  onSelectedEvent = (event: InternalTemplates) => null,
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  getIsTemplateEventDisabled = (event: UserSelectedInternalTemplate) => true,
  onCreateNew = noop,
}) => {
  const navigate = useNavigate();
  const navigateWithSelection = (selectedEvent: InternalTemplates) => {
    onSelectedEvent(selectedEvent);
    navigate(`/predictive-audiences/goals/create`);
  };
  const navigateToNew = () => {
    onCreateNew();
    navigate(`/predictive-audiences/goals/create`);
    // Reset users' view to top of page given the lower positioning of the button
    window.scrollTo(0, 0);
  };
  return (
    <IndexPageContainer
      data-background-color={colors.backgroundSecondary}
      data-test={PageTestIds.TemplatesInitialPage}
    >
      <IndexPageTitle>{INDEX_PAGE_TITLE}</IndexPageTitle>
      <TemplateSection
        getIsTemplateEventDisabled={getIsTemplateEventDisabled}
        onTemplateSelection={navigateWithSelection}
      />
      <IndexPageCreateNewContainer>
        <IndexPageCreateNewText>{INDEX_PAGE_CREATE_TEXT}</IndexPageCreateNewText>
        <IndexPageCreationButton
          data-test={PageTestIds.TemplatesInitialPageCreate}
          onClick={navigateToNew}
          size={BUTTON_SIZES.LARGE}
          variant={BUTTON_VARIANTS.SECONDARY}
        >
          {INDEX_PAGE_CREATE_BUTTON_TEXT}
        </IndexPageCreationButton>
      </IndexPageCreateNewContainer>
    </IndexPageContainer>
  );
};
